// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'video';

export const Component = () => (
  <path d='M7.371 8.97c.335 0 .479.144.479.48 0 .334-.144.478-.479.478H4.45c-.335 0-.527-.144-.527-.479 0-.335.192-.479.527-.479h2.921Zm17.194-1.963v10.776a.943.943 0 0 1-.288.67c-.239.24-.479.335-.718.335a.922.922 0 0 1-.575-.191l-4.31-3.113v1.82c0 .43-.144.766-.432 1.053a1.408 1.408 0 0 1-1.054.431H2.485c-.431 0-.766-.143-1.054-.431A1.408 1.408 0 0 1 1 17.303V7.485c0-.431.144-.766.431-1.054A1.408 1.408 0 0 1 2.485 6h14.703c.432 0 .767.144 1.054.431.288.288.431.623.431 1.054v1.82l4.31-3.114A.919.919 0 0 1 23.56 6c.239 0 .479.096.718.287a.976.976 0 0 1 .288.72Zm-6.897 10.297V7.486c0-.335-.144-.479-.479-.479H2.486c-.335 0-.527.144-.527.479v9.818c0 .335.192.479.527.479h14.703c.335 0 .479-.144.479-.48Zm5.891.479V7.007l-4.885 3.496v3.784l4.885 3.496Z' />
);

export const viewBox = '0 0 25 25';
